<template>
  <div>
    <div class="ptc_container">
      <div class="login_contant">
        <h3 class="login_tit">비밀번호 찾기</h3>
        <div class="login_form">
          <span>아이디</span>
          <div class="column_input">
            <input
                v-model="input.loginId"
                type="text"
                :class="{'validation_error' : validObj.loginId.active}"
                v-bind:readonly="emailAuth.flag"
                placeholder="아이디를 입력하세요."/>
            <p v-show="validObj.loginId.active" class="validation_text" v-text="validObj.loginId.msg"></p>
          </div>
          <span>이메일</span>
          <div class="column_input">
            <ul class="inp_column btn">
              <li>
                <input
                    v-model="input.email"
                    @keyup.enter="submit"
                    type="text"
                    :class="{'validation_error' : validObj.email.active}"
                    v-bind:readonly="emailAuth.flag"
                    placeholder="이메일을 입력하세요."/>
                <p v-show="validObj.email.active" class="validation_text" v-text="validObj.email.msg"></p>
              </li>
              <li class="col_btn">
                <button type="button" class="inp_btn" @click="sendEmailAuthCode" v-bind:disabled="emailAuth.flag">
                  <span v-if="!emailAuth.sendYn">인증번호발송</span>
                  <span v-else>인증번호발송</span>
                </button>
              </li>
            </ul>
          </div>
          <span v-show="emailAuth.sendYn">이메일 인증번호</span>
          <div class="column_input" v-show="emailAuth.sendYn">
            <ul class="inp_column btn">
              <li>
                <input type="text" maxlength="80"
                       :class="emailAuth.validMessage != null && emailAuth.validMessage != ''? `validation_error` : ``"
                       v-model="emailAuth.value" v-bind:readonly="emailAuth.flag"/>
                <span style="color: red">{{ displayTime }}</span>
                <p v-show="emailAuth.validMessage != null && emailAuth.validMessage != ''"
                   class="validation_text">
                  {{ emailAuth.validMessage }}
                </p>
              </li>
              <li class="col_btn">
                <button type="button" class="inp_btn" @click="verificationEmailAuthCode" v-bind:disabled="emailAuth.flag">
                  인증번호 확인
                </button>
              </li>
            </ul>
          </div>
          <div class="login_msg_area">
              <p class="login_msg">인증번호가 오지 않나요?</p>
              <!--
                  * 1024해상도 아래에서는 tooltip_ico 클릭할 경우 tooltip_box에 active 클래스 추가
              -->
              <div class="tooltip_box">
                  <span class="tooltip_ico"></span>
                  <div class="tooltip_txt">
                      <p>발송한 메일이 스팸 메일로 분류된 것은 아닌지 확인해주세요. 스팸 메일함에도 메일이 없다면, 다시 한 번 ‘인증번호발송’을 눌러주세요.</p>
                  </div>
              </div>
          </div>
          <div class="bottom_area">
            <ul class="column col_2">
              <li>
                <button type="button" class="login_btn type2" @click="submit">패스워드 찾기</button>
              </li>
              <li>
                <button type="button" class="login_btn"
                        @click="$router.push('/account/logout')">로그인
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";
import SectionHeader from "@/components/platform/SectionHeader";

export default {
  components: {
    MiddleContainer,
    ContentHeader,
    SectionHeader,
  },
  data() {
    return {
      input: {},
      results: null,
      validObj: {
        loginId: {
          active: false,
          msg: "필수 입력 항목입니다.",
        },
        email: {
          active: false,
          msg: "필수 입력 항목입니다.",
        }
      },
      emailAuth: {
        value: null,
        validMessage: null,
        sendYn: false,
        flag: false
      }, //sendYn : 메일발송여부, flag : 이메일 인증 성공여부
      settingTime: 300, //필요한 초만큼 입력
      checkTime: null,
      displayTime: null,
      timeCheckObj: null,
      authId: null,
    };
  },
  methods: {
    async submit() {
      this.checkValidate();
      if (this.validObj.loginId.active || this.validObj.email.active) {
        return;
      }

      if (!this.emailAuth.flag) {
        alert('이메일 인증을 먼저 진행해주세요.')
        return;
      }

      const data = await this.$wApi.user.mypage.check.password(this.input, null);
      if (data.error) {
        window.alert(data.message);
        this.emailAuth.sendYn = false;
        this.emailAuth.flag = false;
        this.emailAuth.value = null;
      } else {
        window.alert("등록된 이메일주소로 임시 비밀번호가 발급되었습니다.");
        this.$router.push("/account/login");
      }
      if (!data) return;
      this.results = data;
    },
    //이메일 정규식 체크
    email_check(email) {
      const reg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      return reg.test(email);
    },
    checkValidate() {
      if (this.input?.loginId?.length == 0 || !this.input?.loginId?.length) {
        this.setValidObj("loginId", true);
      } else {
        this.setValidObj("loginId", false);
      }

      if (this.input?.email?.length == 0 || !this.input?.email?.length) {
        this.setValidObj("email", true);
      } else if (!this.email_check(this.input?.email)) {
        this.setValidObj("email", true, "이메일을 형식에 맞게 입력해 주세요.");
      } else {
        this.setValidObj("email", false);
      }
    },
    setValidObj(name, active, msg) {
      this.validObj[name].active = active;
      if (msg) {
        this.validObj[name].msg = msg;
      }
    },
    async sendEmailAuthCode() {
      //console.log('sendEmailAuthCode 호출');
      //이메일 정규식 확인
      if (!this.email_check(this.input?.email)) {
        this.setValidObj("email", true, "이메일을 형식에 맞게 입력해 주세요.");
        return;
      } else {
        this.setValidObj("email", false);
      }
      if (this.emailAuth.flag) {
        alert('이미 인증되었습니다.')
        return;
      }

      try {
        //todo 빽단에서 sendmail 시도
        const data = await this.$wApi.user.emailAuth.create({
          email: this.input.email,
          findFlag: true
        }, null, {
          useError: true,
        });

        if (data?.error === true) {
          alert(data.message);
          return;
        }

        if (data.id) {
          this.authId = data.id;
          //메일 전송여부
          this.emailAuth.sendYn = true
          //메일 인증 시각
          this.checkTime = this.settingTime;
          //setTimeout 초기화
          if (this.timeCheckObj != null) {
            clearTimeout(this.timeCheckObj);
          }
          //메일 인증 시각 함수
          this.fnTimeCheck();
          alert("발송되었습니다.");
        } else {
          alert("발송에 실패하였습니다. 다시 시도해주세요.");
        }

      } catch (e) {
        console.log(e)
      }
    },

    async verificationEmailAuthCode() {
      //console.log('verifycationEmailAuthCode 호출');
      //기입력한 메일과 현재 입력한 메일의 값이 동일한 경우만 이메일인증코드 확인절차 실행.
      if (this.emailAuth.flag) {
        alert('이미 인증되었습니다.');
        return;
      }

      try {
        //todo 빽단에서 인증절차 시도(인증코드/메일 db와 input 비교)
        const result = await this.$wApi.user.emailAuth.verification({
          id: this.authId,
          emailAuthCode: this.emailAuth.value,
          email: this.input.email
        }, null, {
          useError: true,
        });

        if (result?.error === true) {
          alert(result.message);
          return;
        }
        if (result) {
          alert('인증이 완료되었습니다.');
          this.emailAuth.flag = true;
          if (this.timeCheckObj != null) {
            clearTimeout(this.timeCheckObj);
            this.displayTime = "";
          }
        } else {
          alert('인증이 실패되었습니다. \n 다시 시도해주세요.');
        }

      } catch (e) {
        console.log(e)
        alert('인증이 실패되었습니다. \n 다시 시도해주세요.');
      }
    },

    fnTimeCheck() {
      if (this.checkTime > 0) {
        const m = Math.floor(this.checkTime / 60);
        let s = this.checkTime % 60;
        if (s < 10) s = "0" + s;
        const time = m + ":" + s;
        this.displayTime = time
        this.checkTime--;
        this.timeCheckObj = setTimeout(this.fnTimeCheck, 1000);
      } else {
        this.displayTime = "0:00";
        this.emailAuth.sendYn = false;
        this.emailAuth.flag = false;
        this.emailAuth.value = null;
        this.authId = null;
        alert("입력시간을 초과했습니다.");
      }
    },
  }, //method
};
</script>
